import React, { useEffect, useState } from "react";
import { Mail, Phone, MapPin } from "lucide-react";
import { toast } from "sonner";
import api, { apiErr } from "@/lib/api";
import { useI18n } from "@/lib/i18n";
import PageHero from "@/components/PageHero";
import { Field, Input, Textarea } from "@/components/Field";
import Seo from "@/components/Seo";

export default function Contact() {
  const { t, lang } = useI18n();
  const [f, setF] = useState({ name: "", email: "", phone: "", subject: "", message: "" });
  const [settings, setSettings] = useState({});
  const [loading, setLoading] = useState(false);
  useEffect(() => { api.get("/settings").then((r) => setSettings(r.data)).catch(() => {}); }, []);
  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/contact", f);
      toast.success(t("contact.success"));
      setF({ name: "", email: "", phone: "", subject: "", message: "" });
    } catch (err) { toast.error(apiErr(err)); }
    setLoading(false);
  };
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  return (
    <div>
      <Seo title={t("contact.title")} />
      <PageHero eyebrow={t("nav.contact")} title={t("contact.title")}
        subtitle={lang === "de" ? "Wir freuen uns auf Ihre Nachricht." : "We look forward to your message."} />
      <section className="container-x py-14 grid lg:grid-cols-3 gap-10">
        <div className="space-y-5">
          {[[Mail, settings.company_email], [Phone, settings.company_phone], [MapPin, settings.company_address]].map(([Icon, val], i) => (
            <div key={i} className="flex items-start gap-3">
              <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary/10 text-primary shrink-0"><Icon size={18} /></div>
              <span className="text-sm text-muted-foreground pt-2">{val}</span>
            </div>
          ))}
        </div>
        <form onSubmit={submit} className="lg:col-span-2 surface p-8 space-y-4" data-testid="contact-form">
          <div className="grid sm:grid-cols-2 gap-4">
            <Field label={t("common.name")}><Input testid="contact-name" required value={f.name} onChange={set("name")} /></Field>
            <Field label={t("common.email")}><Input testid="contact-email" type="email" required value={f.email} onChange={set("email")} /></Field>
          </div>
          <div className="grid sm:grid-cols-2 gap-4">
            <Field label={t("auth.phone")}><Input testid="contact-phone" value={f.phone} onChange={set("phone")} /></Field>
            <Field label={t("contact.subject")}><Input testid="contact-subject" value={f.subject} onChange={set("subject")} /></Field>
          </div>
          <Field label={t("contact.message")}><Textarea testid="contact-message" required value={f.message} onChange={set("message")} /></Field>
          <button className="btn-primary" disabled={loading} data-testid="contact-submit">{loading ? "…" : t("common.send")}</button>
        </form>
      </section>
    </div>
  );
}
